import { Pipe, PipeTransform } from '@angular/core';
import { SignatureRequestStatus } from './signature-request.model';
@Pipe({
  name: 'signatureRequestStatusLabel',
})
export class SignatureRequestStatusLabelPipe implements PipeTransform {
  transform(value: SignatureRequestStatus | null | undefined, ...args: unknown[]): string {
    if (!value) {
      return '';
    }
    switch (value) {
      case 'draft':
        return 'Brouillon';
      case 'ongoing':
        return 'En cours';
      case 'done':
        return 'Signée';
      case 'deleted':
        return 'Supprimée';
      case 'expired':
        return 'Expirée';
      case 'canceled':
        return 'Annulée';
      case 'approval':
        return 'En attente de validation';
      case 'rejected':
        return 'Rejetée';
      case 'declined':
        return 'Refusée';
      case 'paused':
        return 'En pause';
      default:
        return assertNever(value);
    }
  }
}

function assertNever(value: never): never {
  throw new Error(`Unhandled status: ${value}`);
}
